import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Accordion,
  AccordionContext,
  Col,
  Row,
  useAccordionButton,
} from 'react-bootstrap';
import {
  SSectionTitle,
  SContainer,
  SSection,
  SFaq,
  SFaqTitle,
  SFaqTitleContainer,
  SFaqBody,
  SDotSVG,
} from './styles';
import { AiOutlinePlusSquare } from '@react-icons/all-files/ai/AiOutlinePlusSquare';
import { AiOutlineMinusSquare } from '@react-icons/all-files/ai/AiOutlineMinusSquare';

function ContextAwareTitleToggle({ children, eventKey, callback, color }) {
  const { activeEventKey } = useContext(AccordionContext);

  const decoratedOnClick = useAccordionButton(
    eventKey,
    () => callback && callback(eventKey),
  );

  const isCurrentEventKey = activeEventKey === eventKey;

  return (
    <SFaqTitle
      className={isCurrentEventKey ? 'active' : 'inactive'}
      onClick={decoratedOnClick}
      color={color}
    >
      <SFaqTitleContainer>
        <span className="title">{children}</span>
        <span className="svg-container">
          {isCurrentEventKey ? (
            <AiOutlineMinusSquare size={30} />
          ) : (
            <AiOutlinePlusSquare size={30} />
          )}
        </span>
      </SFaqTitleContainer>
    </SFaqTitle>
  );
}

ContextAwareTitleToggle.propTypes = {
  children: PropTypes.node,
  eventKey: PropTypes.string,
  callback: PropTypes.any,
  color: PropTypes.string,
};

function LandingFAQ({ data, theme = 'white' }) {
  const { activeEventKey } = useContext(AccordionContext);
  const [activeFaqKey, setActiveFaqKey] = useState('');

  return (
    <SSection color={theme}>
      <SDotSVG variant={'pastel_blue'} top right />
      <SContainer>
        <Row>
          <Col xs="12" md="10" className="offset-md-1">
            <SSectionTitle color={theme}>FAQs</SSectionTitle>
          </Col>

          <Col xs="12" md="10" className="offset-md-1">
            <Accordion defaultActiveKey="">
              <Row>
                {data.map((faq, index) => {
                  const isCurrentEventKey = activeFaqKey === String(index);
                  return (
                    <Col xs="12" md={6} key={index} className="mb-3">
                      <SFaq>
                        <ContextAwareTitleToggle
                          eventKey={String(index)}
                          callback={key => setActiveFaqKey(key)}
                          color={theme}
                        >
                          {faq.title}
                        </ContextAwareTitleToggle>
                        <Accordion.Collapse eventKey={String(index)}>
                          <SFaqBody
                            className={
                              isCurrentEventKey ? 'active' : 'inactive'
                            }
                            color={theme}
                          >
                            {faq.body}
                          </SFaqBody>
                        </Accordion.Collapse>
                      </SFaq>
                    </Col>
                  );
                })}
              </Row>
            </Accordion>
          </Col>
        </Row>
      </SContainer>
    </SSection>
  );
}

LandingFAQ.propTypes = {
  data: PropTypes.any,
  theme: PropTypes.string,
};
export default LandingFAQ;
